// extracted by mini-css-extract-plugin
export var title = "K_h";
export var titleWhite = "K_b8";
export var variant1 = "K_bC";
export var variant2 = "K_bD";